export default __webpack_public_path__ + "vision-external-camera-thumbnail-480-76b6c237243f2cd6a043288dbbf0418a.png";